import { render, staticRenderFns } from "./CompanyLanding.vue?vue&type=template&id=56acadac&scoped=true"
import script from "./CompanyLanding.vue?vue&type=script&lang=js"
export * from "./CompanyLanding.vue?vue&type=script&lang=js"
import style0 from "./CompanyLanding.vue?vue&type=style&index=0&id=56acadac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56acadac",
  null
  
)

export default component.exports